var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"app-bar",attrs:{"app":true,"hide-on-scroll":true,"rounded":true,"color":"white"}},[_c('app-button-icon',{class:_vm.toggleIconClasses,attrs:{"icon":"chevron-left"},on:{"click":_vm.handleClick}}),_c('div',{staticClass:"ml-auto"},[_c('b',[_vm._v("username:")]),_vm._v(" "+_vm._s(_vm.authorizedUser.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }